'use strict';

/**
 * EventsAndNewsTeaser
 *
 * @author Matthias Giger <matthias.giger@namics.com>
 */
T.Module.EventsAndNewsTeaser = T.createModule({

	_selectors: {
		event: '[data-js-m-events-and-news-teaser__item]',
		title: '[data-js-m-events-and-news-teaser__item-title-main]',
		tooLong: '[data-js-m-events-and-news-teaser__item-title-too-long]'
	},

	start: function start(resolve) {
		// References
		this.$ctx = $(this._ctx);
		this.charLimit = 100;

		// Data
		this.$items = this.$ctx.find(this._selectors.event);

		this._events.on('viewport.setup', this.onViewportSetup.bind(this));
		this._events.on('t.sync', this.sync.bind(this));

		resolve();
	},
	sync: function sync() {
		var _this = this;

		this.$items.each(function (index, element) {
			return _this.cutTitleIfNecessary(element);
		});
	},
	cutTitleIfNecessary: function cutTitleIfNecessary(element) {
		var $element = $(element);
		var $title = $element.find(this._selectors.title);
		var $tooLong = $element.find(this._selectors.tooLong);
		var title = $title.text();

		if (title.length > this.charLimit) {
			var titleCut = title.substr(0, this.charLimit);
			var lastSpaceIndex = titleCut.lastIndexOf(' ');

			// check if last char is in the middle of a word and find last space
			if (lastSpaceIndex <= titleCut.length - 1) {
				titleCut = titleCut.substring(0, lastSpaceIndex);
			}

			$title.text(titleCut);
			$tooLong.show();
		}
	},
	onViewportSetup: function onViewportSetup(wpName) {
		switch (wpName) {
			case 'small-down':
				this.charLimit = 60;
				break;
			default:
				this.charLimit = 100;
				break;
		}
	}
});